import { createFileRoute } from '@tanstack/react-router';
import { BreakScreen } from '../features/break/BreakScreen';
import { RequireAuth } from '../features/auth/RequireAuth';

export const Route = createFileRoute('/break')({
  component: BreakRoute,
});

function BreakRoute(): React.JSX.Element {
  // Скільки лишилось відпочивати, екран питає в сервера сам: у параметрі
  // адреси цьому числу не місце, бо адресу дитина може виправити.
  //
  // Перерва — частина дитячого маршруту: вона веде назад на арену, куди
  // батькові ходу немає. Тому й сам екран тримаємо за тією ж роллю.
  return <RequireAuth role="child">{(me) => <BreakScreen me={me} />}</RequireAuth>;
}
